import supportsPerformanceAPI from './supportsPerformanceAPI';

/**
 * Wrapper around Performance.measure to deal with old browsers and to clear existing marks.
 */
export default (
  measureName: string,
  startOrMeasureOptions: undefined | string | PerformanceMeasureOptions,
  endMark: undefined | string,
): PerformanceMeasure | void => {
  if (!supportsPerformanceAPI()) {
    return undefined;
  }

  // Clear previous measure
  performance.clearMeasures(measureName);

  return performance.measure(measureName, startOrMeasureOptions, endMark);
};
